import { cn } from "@/lib/utils";
// Official vector wordmarks shared with shugert.es. Served from /public/brand
// so both the app and crawlers (JSON-LD `logo`) resolve the same file.
const LOGO_SRC = "/brand/shugert-wordmark-black.svg";
const LOGO_WHITE_SRC = "/brand/shugert-wordmark-white.svg";

type LogoProps = {
  className?: string;
  alt?: string;
  /** `light` renders the official white wordmark for Jet/Charcoal surfaces. */
  tone?: "dark" | "light";
};

// The site is locked to light mode (see root suppressHydrationWarning +
// themeScript), so render only the dark-ink logo to avoid a second
// above-the-fold image request.
export function Logo({ className, alt = "Shugert Shopify Agency Logo", tone = "dark" }: LogoProps) {
  return (
    <img
      src={tone === "light" ? LOGO_WHITE_SRC : LOGO_SRC}
      alt={alt}
      width={1250}
      height={343}
      decoding="async"
      className={cn("block", className)}
    />
  );
}
